module.exports = __webpack_public_path__ + "img/people-04.212e509c.png";